module.exports = __webpack_public_path__ + "static/media/after_large.fe477754.jpeg";